import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

const selectFulfillmentPlanSets = (state) => get(state, 'fulfillmentPlanSets', emptyObject);

export const selectFulfillmentPlanSetById = (state, props) => get(selectFulfillmentPlanSets(state, props), props.fulfillmentPlanSetId);
export const selectFulfillmentPlanSetProperty = (state, props) => get(selectFulfillmentPlanSetById(state, props), props.property);
